import { DataGridPro, GridActionsCellItem, GridRowModes, useGridApiRef } from '@mui/x-data-grid-pro';
import React, { useEffect, useState, useRef } from 'react'
import { useDispatch } from 'react-redux';
import { APP_ACTIONS, APP_VIEW, dateFilterOperators } from '../../constants/constant';
import { CLEAR_EXCEL, EXPORT_EXCEL_REQUEST } from '../../store/types';
import { useSelector } from "react-redux";
import { canBPApprove, canBPReject, isActionVisible } from '../../utils/utils';
import { Check, Close, Edit, Person, SaveAsSharp } from '@mui/icons-material';
import DetailPanelFunction from '../detail-panel-function';
import './grid.css';
import GridToolbar from './grid-toolbar';
import { Tooltip } from '@deere/fuel-react';
import dayjs from 'dayjs';

function ExtDataGrid(props) {
    const [rowModesModel,setRowModesModel] = useState({});
    const [expandedRowIds,setExpandedRowIds] = useState([]);
    const [isInEditMode,setIsInEditMode] = useState(false);
    const [editedValues,setEditedvalues] = useState(props.editableFields);
    const [isAllExpanded,setIsAllExpanded] = useState(false);
    const userData = useSelector((state) => state.userState.userData);
    const gridApiRef = useGridApiRef();
    const dispatch = useDispatch();
    const prevRowsRef = useRef();

    const [paginationModel, setPaginationModel] = useState({
      pageSize: 10,
      page: 0,
    });

    useEffect(()=>{},[paginationModel])

    useEffect(() => {
      if(props.rows && props.rows.length > 0 && props.rows !== prevRowsRef.current) {
        prevRowsRef.current = props.rows;
        dispatch({ type: EXPORT_EXCEL_REQUEST, payload: props.rows });
      }
      else if (!props.rows || props.rows.length === 0) {
      dispatch({ type: CLEAR_EXCEL });
      }
    }, [props.rows, dispatch]);

    const handleExpandedRowIdChange = (newIds)=>{
        setExpandedRowIds(newIds);
    }
    const handleRowModesModalChange = (newRowModesModal)=> setRowModesModel(newRowModesModal);

    const setRowModeAsEdit = (row)=>{setRowModesModel({
      [row.id]: {mode: GridRowModes.Edit}
    })}

    const setRowModeAsView= (row)=>{setRowModesModel({
      [row.id]: {mode: GridRowModes.View}
    });}

    useEffect(()=>{},[expandedRowIds,isInEditMode]);

    const handleEditClick=(row) =>{
      setEditedvalues(row);
      setRowModeAsEdit(row);
      setExpandedRowIds((prev) => prev.includes(row.id) ? prev : [...prev, row.id]);
      setIsInEditMode(true);
    }

    const handleCloseClick=(row)=>{
      setEditedvalues({});
      setIsInEditMode(false);
      setRowModeAsView(row);
    }

    const handleSaveClick = (row)=>{
      props.save({...editedValues,id: row.id});
      setIsInEditMode(false);
      setRowModeAsView(row);
    }

 const handleAction = (row, action) => {
  if (action === APP_ACTIONS.APPROVE) {
    const newDate = new Date(row.newCalculatedDate);
    const originalDate = new Date(row.originalDocDate);
    const diffInMonths = (newDate.getFullYear() - originalDate.getFullYear()) * 12 + (newDate.getMonth() - originalDate.getMonth());

    if (diffInMonths > 24) {
      props.approve(row.id, row.requestStatus, true); // pass flag for date exceed
    } else {
      props.approve(row.id, row.requestStatus, false);
    }
  } else if (action === APP_ACTIONS.SENDTOCCM) {
    props.sendToCCM(row.id, row.requestStatus);
  } else if (action === APP_ACTIONS.SENDTOBP) {
    props.sendToBP(row.id, row.requestStatus);
  } else if (action === APP_ACTIONS.REJECT) {
    props.reject(row.id, row.requestStatus);
  }
};


    const hasActionsColumn = Array.isArray(props.columns) && props.columns.some((column) => column.field === 'actions');

    const columns = props.manualRequestActions && !hasActionsColumn ? [...props.columns,
        {
          field: 'actions',
          headerName: 'Actions',
          type: 'actions',
          width: 100,
          getActions: ({ row }) => row.requestStatus === 'Pending' ? [] : [
              <GridActionsCellItem
                icon={<Check />}
                label="Approve"
                onClick={() => props.manualRequestActions.onApprove(row.id)}
                disabled={props.manualRequestActions.isConfirming || row.requestStatus !== 'Manual_New'}
                showInMenu={false}
              />,
            ],
        },
      ] : props.view === APP_VIEW.LOGS ? [...props.columns, 
      {
        field: 'newReasonCode',
        headerName: 'New Reason Code',
        type: 'string',
        renderHeader: ()=>{return(<strong>New Reason Code</strong>)},
        width: 180,
        editable: false
      },
      {
        field: 'processingtime',
        headerName: 'Processed On',
        type: 'string',
        renderHeader: ()=>{
          return(<strong>Processed On</strong>)
        },
        width: 180,
        editable: false,
        filterOperators: dateFilterOperators,
        renderCell: (params) => {
          if (params.row.requestStatus === 'Not_Processed_By_FS') {
            return '-';
          }
          return params.value
          ? dayjs(params.value).format('DD-MM-YYYY')
          : '-';
         },
      },
      {
        field: 'userID',
        headerName: 'Processed By',
        type: 'string',
        renderHeader: ()=>{
          return(<strong>Processed By</strong>)
        },
        width: 150,
        editable: false,
        renderCell: (params) => {
          if (params.row.requestStatus === 'Not_Processed_By_FS') {
            return '';
          }
          return params.value || '';
         },
      }
    ] : isActionVisible(props.view,userData) ? [
        ...props.columns,
        {
          field: 'actions',
          headerName: 'Actions',
          type: 'actions',
          renderHeader: ()=>{return(<strong>Actions</strong>)},
          width: 180,
          renderCell: ({row})=>{
            return isInEditMode && rowModesModel[row.id] && rowModesModel[row.id].mode ?
               (
                <div className="grid-actions">
                  <Tooltip title="Close">
                <GridActionsCellItem
                  icon={<Close/>}
                  label='close'
                  sx={{
                    color: 'primary.main',
                  }}
                  onClick={()=>handleCloseClick(row)}
                  disabled={props.isDisabled}
                />
                </Tooltip>
                <Tooltip title="Save" arrow>
                <GridActionsCellItem
                  icon={<SaveAsSharp/>}
                  label='save'
                  sx={{
                    color: 'primary.main',
                  }}
                  onClick={()=>{
                    if (
                      (props.view === APP_VIEW.CCM &&
                        editedValues["downPaymentPercentage"] > -1 &&
                        editedValues["downPaymentAmount"] > -1 &&
                        !isNaN(editedValues["downPaymentPercentage"]) &&
                        !isNaN(editedValues["downPaymentAmount"])) ||
                      props.view !== APP_VIEW.CCM
                    ) {
                    handleSaveClick(row)
                  }
                  }}
                  disabled={props.isDisabled}
                />
                </Tooltip>
                </div>
              )
            :
             (
              <div className="grid-actions">
              <Tooltip title="Edit" arrow>
              <GridActionsCellItem
                icon={
                <Edit />
              }
                label='Edit'
                className='textPrimary'
                color='inherit'
                onClick={()=>handleEditClick(row)}
                disabled={props.isDisabled}
              />
              </Tooltip>
              {props.sendToCCM ? 
              <Tooltip title="Send to CCM">
              <GridActionsCellItem
                icon={<Person />}
                label='Send to CCM'
                className='textPrimary'
                color='inherit'
                onClick={()=>{handleAction(row,APP_ACTIONS.SENDTOCCM)}}
                disabled={props.isDisabled}
              />
              </Tooltip>
              : null}
              {props.sendToBP ? 
              <Tooltip title={row.creditLimitExceeded ? "Credit limit exceeded - cannot send to BP" : "Send to BP"}>
              <GridActionsCellItem
                icon={<Person />}
                label='Send to BP'
                className='textPrimary'
                color='inherit'
                onClick={()=>handleAction(row,APP_ACTIONS.SENDTOBP)}
                disabled={props.isDisabled || row.creditLimitExceeded === true}
              />
              </Tooltip>
              : null}
              {props.reject && ((props.view === APP_VIEW.BP && canBPReject(row.extensionType)) || (props.view === APP_VIEW.CCM)) ?
                <Tooltip title="Reject" arrow>
                <GridActionsCellItem
                icon={<Close />}
                label='Reject'
                className='textPrimary'
                color='inherit'
                onClick={()=>handleAction(row,APP_ACTIONS.REJECT)}
                disabled={props.isDisabled}
              /> 
              </Tooltip>
              : null}
              {((props.view === APP_VIEW.BP && canBPApprove(row.extensionType)) || props.view === APP_VIEW.CCM) ?
              <Tooltip title="Approve" arrow>
              <GridActionsCellItem
                icon={<Check />}
                label='Approve'
                className='textPrimary'
                color='inherit'
                onClick={()=>handleAction(row,APP_ACTIONS.APPROVE)}
                disabled={props.isDisabled}
              />
              </Tooltip>
              :null}
            </div>
          )
          },
        },
      ]: props.columns;

    const detailPanel = ({row})=>{
        return(
            <DetailPanelFunction
            pageView={props.view}
            view={(props.view===APP_VIEW.LOGS || props.view===APP_VIEW.ERRORS) ? props.panelView : props.view}
            row={row}
            onChange={setEditedvalues}
            editableFields={props.editableFields}
            enableEditing={isInEditMode && rowModesModel[row.id] && rowModesModel[row.id].mode ? row.id : null}
            />
        );
    }

    const handleExpandAll =()=>{
      if(isAllExpanded){
        setExpandedRowIds([]);
        setIsAllExpanded(false);
      }else{
        setExpandedRowIds(props.rows.map(row=>row.id));
        setIsAllExpanded(true);
      }
    }

  return (
    <div style={{height:`${paginationModel.pageSize*52+60}px`,maxHeight:'700px',width:'100%'}}>
        <DataGridPro
            loading={props.isLoaderVisible}
            apiRef={gridApiRef}
            rowModesModel={rowModesModel}
            handleRowModesModalChange={handleRowModesModalChange}

            rows={props.rows}
            columns={columns}
            checkboxSelection={props.checkboxSelection}
            rowSelectionModel={props.rowSelectionModel}
            onRowSelectionModelChange={props.onRowSelectionModelChange}
            isRowSelectable={props.isRowSelectable}
            getDetailPanelContent={props.disableDetailPanel ? undefined : detailPanel}
            getDetailPanelHeight={props.disableDetailPanel ? undefined : ({row})=>'auto'}
            detailPanelExpandedRowIds={expandedRowIds}
            onDetailPanelExpandedRowIdsChange={handleExpandedRowIdChange}

            pagination
            paginationModel={paginationModel}
            onPaginationModelChange={setPaginationModel}
            pageSizeOptions={[5, 10, 15, 20, 25, 30, 50, 100]}

            slots={{
              toolbar: GridToolbar,
            }}
            slotProps={{
              toolbar:{
                view: props.view,
                isAllExpanded,
                handleExpandAll,
                disableExpandAll: props.disableDetailPanel,
                showToast: props.showToast,
                confirmSelectedManualRequests: props.confirmSelectedManualRequests,
                isConfirmingManualRequests: props.isConfirmingManualRequests,
                deleteSelectedManualRequests: props.deleteSelectedManualRequests,
                isDeletingManualRequests: props.isDeletingManualRequests,
                manualRequestSelectedCount: props.manualRequestSelectedCount,
             }
            }}

            disableColumnSelector
            sx={{
              '& .MuiDataGrid-columnHeaders': {
                boxShadow: '0px 8px 8px rgba(0,0,0,0.1)',
              },
              '& .MuiDataGrid-columnHeader': {
                backgroundColor: '#fff',
              },
              '& .MuiDataGrid-cell': {
                backgroundColor: '#fff',
              },
              '& .MuiDataGrid-row': {
                backgroundColor: '#fff',
                boxShadow: '0px 0px 8px rgba(0,0,0,0.2)',
               // margin: '3px',
               
              },
              '& .MuiDataGrid-filler': {
                // display:'none',
                backgroundColor: '#fff'
              },
              boxShadow : '0px 4px 8px rgba(0,0,0,0.1)',
              borderRadius: '8px',
              padding: '4px',
              backgroundColor: '#fff',
              marginBottom: '10px',
            }}
        />
    </div>
  )
}

export default ExtDataGrid;